export class SearchTermJobService implements IService {
  private readonly ItemResource;

  constructor($resource: any, configService: any, resourceWrapperService: any) {
    const searchTermJobResource = $resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/searchtermlist/:searchTermListId/job/:id`,
      {'id': '@id', 'projectId': '@projectId', 'searchTermListId': '@searchTermListId'},
      {
        update: {method: "PUT"},
        query: {method: "GET", isArray: false},
        run: {
          method: "POST",
          url: `${configService.getServerBaseUrlForResource()}/project/:projectId/searchtermlist/:searchTermListId/job/run`
        },
        cancel: {
          method: "POST",
          url: `${configService.getServerBaseUrlForResource()}/project/:projectId/searchtermlist/:searchTermListId/job/cancel`
        },
        status: {
          method: "GET",
          url: `${configService.getServerBaseUrlForResource()}/project/:projectId/searchtermlist/:searchTermListId/job/status`
        }
      }
    );
    this.ItemResource = resourceWrapperService.WrapActions(searchTermJobResource);
  }

  public async FindOne(id: string, projectId: string, searchTermListId: string) {
    return this.ItemResource.get({id: id, projectId: projectId, searchTermListId: searchTermListId}).$promise;
  }

  public async FindAll(projectId: string, searchTermListId: string): Promise<any> {
    return this.ItemResource.query({
      projectId: projectId,
      searchTermListId: searchTermListId
    }).$promise;
  }

  public Run(projectId: string, searchTermListId: string) {
    return this.ItemResource.run({
      searchTermListId: searchTermListId,
      projectId: projectId
    }).$promise;
  }

  public Cancel(projectId: string, searchTermListId: string) {
    return this.ItemResource.cancel({
      searchTermListId: searchTermListId,
      projectId: projectId,
    }).$promise;
  }

}

frontendApp.factory("SearchTermJobService", ['$resource', 'ConfigService', 'ResourceWrapperService', function(resource, configService, resourceWrapperService) {
  return new SearchTermJobService(resource, configService, resourceWrapperService);
}]);
